/**
 * 指挥页设备性能 / 网络质量检测（纯逻辑）
 */

/**
 * @returns {'high'|'medium'|'low'}
 */
export function detectDevicePerformanceLevel(nav = typeof navigator !== 'undefined' ? navigator : {}) {
  const hardwareConcurrency = nav.hardwareConcurrency || 1;
  const deviceMemory = nav.deviceMemory || 4;
  if (hardwareConcurrency >= 8 && deviceMemory >= 8) return 'high';
  if (hardwareConcurrency < 4 || deviceMemory < 4) return 'low';
  return 'medium';
}

/**
 * @param {number} latencyMs
 * @returns {'good'|'fair'|'poor'}
 */
export function classifyNetworkQuality(latencyMs) {
  if (latencyMs > 5000) return 'poor';
  if (latencyMs > 2000) return 'fair';
  return 'good';
}

/**
 * @param {(url: string, options?: object) => Promise<Response>} fetchFn
 * @param {string} [testUrl]
 * @returns {Promise<{ latencyMs: number, quality: 'good'|'fair'|'poor' }>}
 */
export async function measureNetworkQuality(fetchFn, testUrl = '/api/device/list?test=1') {
  const startTime = Date.now();
  await fetchFn(testUrl, {
    method: 'HEAD',
    cache: 'no-cache'
  });
  const latencyMs = Date.now() - startTime;
  return {
    latencyMs,
    quality: classifyNetworkQuality(latencyMs)
  };
}

/** 设备性能检测并写回（含日志） */
export function runDashboardDeviceCapabilityCheck(setDevicePerformance, nav = typeof navigator !== 'undefined' ? navigator : {}) {
  const performance = detectDevicePerformanceLevel(nav);
  console.log('设备信息:', {
    userAgent: nav.userAgent,
    platform: nav.platform,
    hardwareConcurrency: nav.hardwareConcurrency || 1,
    deviceMemory: nav.deviceMemory || 4,
    connection: nav.connection
  });
  setDevicePerformance?.(performance);
  console.log(`设备性能等级: ${performance}`);
  console.log('设备性能检测完成，使用用户设置的刷新间隔');
  return performance;
}

/** 网络质量检测并写回（失败时降级刷新间隔） */
export async function runDashboardNetworkQualityCheck(options = {}) {
  const {
    apiFetch,
    setNetworkQuality,
    setRefreshInterval,
    fallbackRefreshIntervalMs = 120000
  } = options;

  try {
    const { latencyMs, quality } = await measureNetworkQuality(apiFetch);
    console.log(`网络延迟检测: ${latencyMs}ms`);
    setNetworkQuality?.(quality);
    if (quality === 'poor') console.log('网络质量较差，建议使用较长刷新间隔');
    else if (quality === 'fair') console.log('网络质量一般，建议使用中等刷新间隔');
    else console.log('网络质量良好，可使用较短刷新间隔');
    return { ok: true, latencyMs, quality };
  } catch (error) {
    console.log('网络检测失败，使用保守设置');
    setNetworkQuality?.('poor');
    setRefreshInterval?.(fallbackRefreshIntervalMs);
    return { ok: false, error };
  }
}
